export const ADDRESSES = [
  {
    label: "Barrio Hermoso",
    value: "Barrio Hermoso",
    id: 1
  },
  {
    label: "Las Orquídeas",
    value: "Las Orquídeas",
    id: 2
  },
  {
    label: "Almirante Brown",
    value: "Almirante Brown",
    id: 3
  },
  {
    label: "Villa Tacuara",
    value: "Villa Tacuara",
    id: 4
  },
  {
    label: "Unión",
    value: "Unión",
    id: 5
  },
  {
    label: "San Lucas",
    value: "San Lucas",
    id: 6
  },
  {
    label: "25 de Mayo",
    value: "25 de Mayo",
    id: 7
  },
  {
    label: "Altos del Paraná I",
    value: "Altos del Paraná I",
    id: 8
  },
  {
    label: "Bicentenario",
    value: "Bicentenario",
    id: 9
  },
  {
    label: "Villa Alta",
    value: "Villa Alta",
    id: 10
  },
  {
    label: "Cataratas",
    value: "Cataratas",
    id: 11
  },
  {
    label: "Libertad",
    value: "Libertad",
    id: 12
  },
  {
    label: "Santa Rosa",
    value: "Santa Rosa",
    id: 13
  },
  {
    label: "Malvinas",
    value: "Malvinas",
    id: 14
  },
  {
    label: "Nuevo Iguazú",
    value: "Nuevo Iguazú",
    id: 15
  },
  {
    label: "2000 Hectáreas",
    value: "2000 Hectáreas",
    id: 16
  },
  {
    label: "Altos del Paraná II",
    value: "Altos del Paraná II",
    id: 17
  }
]